import getQueryString from "../utils/getQueryString"
import sensors from 'sa-sdk-javascript'
// 神策系统配置
sensors.init({
    server_url: 'https://sc.kddbgcky.com/sa?project=YJG01', // 测试地址
  //   server_url: 'https://sc.ngdxxc5b.com/sa?project=JYH01', // 线上地址
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'ajax', // beacon
  show_log: false, // 控制台是否打印
  loadTimeout: 1000, // 设置多少毫秒后开始渲染点击图,因为刚打开页面时候页面有些元素还没加载
  is_track_device_id: true, // 设备id
  heatmap: {
    clickmap: 'default', //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    scroll_notice_map: 'default', //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_delay_time: 4,
    scroll_event_duration: 4 //单位秒，预置属性停留时长 event_duration 的最大值。默认5个小时，也就是300分钟，18000秒。
  }
});
// sensors.quick('autoTrack');
let invite_code = getQueryString('code')
let ghy_version = getQueryString('ghy_version')
sensors.registerPage({
  product_id: 'M40',
  invite_code: invite_code || '',
  ghy_version: ghy_version || '',
  ldy_type: 'original'
});
sensors.use('PageLeave'); // 页面浏览时长
// sensors.use('PageLoad'); // 页面加载时长
export default sensors